export default __webpack_public_path__ + "static/media/logo-promantis.039ddcfd.png";